import type {
  GeneratedThematicSymbol,
  ThematicSymbolDefinition,
  VectorSymbolOverrides,
  VectorSymbols,
} from './model';

function applyGenerated(symbols: VectorSymbols, generated: GeneratedThematicSymbol): VectorSymbols {
  return {
    point: {
      ...symbols.point,
      ...(generated.colour === undefined ? {} : { fillColor: generated.colour }),
      ...(generated.pointRadius === undefined ? {} : { radius: generated.pointRadius }),
    },
    line: {
      ...symbols.line,
      ...(generated.colour === undefined ? {} : { color: generated.colour }),
      ...(generated.lineWidth === undefined ? {} : { width: generated.lineWidth }),
    },
    polygon: {
      ...symbols.polygon,
      ...(generated.colour === undefined ? {} : { fillColor: generated.colour }),
    },
  };
}

function applyOverrides(
  symbols: VectorSymbols,
  overrides: VectorSymbolOverrides | undefined,
): VectorSymbols {
  if (!overrides) return symbols;
  return {
    point: { ...symbols.point, ...overrides.point },
    line: { ...symbols.line, ...overrides.line },
    polygon: { ...symbols.polygon, ...overrides.polygon },
  };
}

/** Resolve base + generated thematic variation + explicit sparse override. */
export function effectiveSymbols(
  base: VectorSymbols,
  thematic?: ThematicSymbolDefinition,
): VectorSymbols {
  if (!thematic) return base;
  return applyOverrides(applyGenerated(base, thematic.generated), thematic.override);
}

export function hasSymbolOverrides(overrides: VectorSymbolOverrides | undefined): boolean {
  return Boolean(
    overrides &&
    ((overrides.point && Object.keys(overrides.point).length > 0) ||
      (overrides.line && Object.keys(overrides.line).length > 0) ||
      (overrides.polygon && Object.keys(overrides.polygon).length > 0)),
  );
}
